module.exports = __webpack_public_path__ + "img/8.4fcd3bd0.png";